module.exports = __webpack_public_path__ + "img/weixin1-01.9843197c.png";